<template>
  <section class="faqGroupBlock defaultSectionMargins container--Medium">
    <aside class="stickyMenu">
      <div v-if="anchorLinks?.length" class="faqGroupBlock__AnchorLinks stickyMenuLinks">
        <button type="button" v-for="button in anchorLinks" @click="scrollToSection(button.id)" :class="{'isActive': button.id === activeSectionId}">{{ button.title }}</button>
      </div>
    </aside>

    <div class="faqGroupBlock__ItemsWrapper">
      <div v-for="block in data" :id="block.anchor_id" class="faqBlockGroup__Item">
        <div v-if="block.faqs?.items?.length" class="faqBlock__List">
          <FaqItem v-for="item in block.faqs.items" :item="item" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
  const props = defineProps({
    data: {},
  });
  const { elements } = useIntersectionObserver((entry) => {
    if (entry.isIntersecting) {
      activeSectionId.value = entry.target.id;
    }
  }, { threshold: 0, rootMargin: '-100px 0px -100px 0px' });
  const activeSectionId = ref(null);

  const anchorLinks = computed(() => props.data.map((block) => ({ id: block.anchor_id, title: block.anchor_title })));

  function scrollToSection(id) {
    activeSectionId.value = id;
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  }

  onMounted(() => {
    elements.value = document.querySelectorAll('.faqBlockGroup__Item');
  });
</script>

<style lang="scss">
  // @import url('@/assets/styles/components/blocks/_faqGroupBlock.scss');
</style>